// import React, { useEffect, useState } from "react";
// import Select from "react-select";
// import { debounce } from "lodash";

// interface OptionType {
//   id: string | number;
//   label: string | number;
// }

// interface PaginatedRouteDropdownProps {
//   placeholder?: string;
//   DropdownHeading?: string;
//   sideDropdownHeading?: string;
//   isMulti?: boolean;
//   badgeBackgroundColor?: string;
//   isDisabled?: boolean;
//   selectedValue?: string | number | (string | number)[];
//   onChange: (
//     value:
//       | OptionType
//       | OptionType[]
//       | string
//       | number
//       | (string | number)[]
//       | null // ✅ Allow null
//   ) => void;

//   fetchOptions: (page: number, searchText?: string) => Promise<OptionType[]>;
//   initialSelectedIds?: (string | number)[];
//   initialSelectedOptions?: OptionType | OptionType[] | null;
//   dependencies?: any[]; // ✅ Triggers re-fetch when changed
// }

// const PaginatedRouteDropdown: React.FC<PaginatedRouteDropdownProps> = ({
//   placeholder = "Select an option...",
//   DropdownHeading = "",
//   sideDropdownHeading = "",
//   isMulti = false,
//   badgeBackgroundColor = "#43B9B2",
//   isDisabled = false,
//   selectedValue,
//   onChange,
//   fetchOptions,
//   initialSelectedIds = [],
//   initialSelectedOptions,
//   dependencies = [],
// }) => {
//   const [options, setOptions] = useState<OptionType[]>([]);
//   const [page, setPage] = useState(1);
//   const [hasMore, setHasMore] = useState(true);
//   const [searchText, setSearchText] = useState("");
//   const [selectedOptions, setSelectedOptions] = useState<OptionType[]>([]);

//   const loadPage = async (pg: number, searchVal = "") => {
//     const newOptions = await fetchOptions(pg, searchVal);
//     setOptions((prev) => (pg === 1 ? newOptions : [...prev, ...newOptions]));
//     setHasMore(newOptions?.length >= 10);
//   };

//   // ✅ Initial fetch
//   useEffect(() => {
//     loadPage(1);
//   }, []);

//   // ✅ Re-fetch on dependency change
//   useEffect(() => {
//     const validDeps = dependencies?.filter((d) => d !== null && d !== undefined);
//     if (!validDeps?.length) return;

//     setPage(1);
//     setSearchText("");
//     loadPage(1);
//   }, [JSON.stringify(dependencies?.filter((d) => d !== null && d !== undefined))]);

//   const debouncedHandleInputChange = debounce((input: string) => {
//     setSearchText(input);
//     setPage(1);
//     loadPage(1, input);
//   }, 300);

//   // ✅ Load from initialSelectedOptions
//   useEffect(() => {
//     if (initialSelectedOptions) {
//       const normalized = Array.isArray(initialSelectedOptions)
//         ? initialSelectedOptions
//         : [initialSelectedOptions];

//       setSelectedOptions(normalized);

//       setOptions((prev) => {
//         const existingIds = prev.map((opt) => opt.id.toString());
//         const newOptions = normalized.filter(
//           (opt) => !existingIds.includes(opt.id.toString())
//         );
//         return [...newOptions, ...prev];
//       });
//     }
//   }, [initialSelectedOptions]);

//   // ✅ Fallback: Load from initialSelectedIds
//   useEffect(() => {
//     if (!initialSelectedIds?.length || initialSelectedOptions) return;

//     const loadInitialSelection = async () => {
//       const fetchedOptions: OptionType[] = [];

//       for (const id of initialSelectedIds) {
//         let currentPage = 1;
//         let found = false;

//         while (!found) {
//           const res = await fetchOptions(currentPage, id.toString());
//           if (!res.length) break;

//           const match = res.find((opt) => opt.id.toString() === id.toString());

//           if (match) {
//             fetchedOptions.push(match);
//             found = true;
//           } else {
//             currentPage++;
//           }
//         }
//       }

//       setOptions((prev) => {
//         const existingIds = prev.map((opt) => opt.id.toString());
//         const newOptions = fetchedOptions.filter(
//           (opt) => !existingIds.includes(opt.id.toString())
//         );
//         return [...newOptions, ...prev];
//       });

//       setSelectedOptions(fetchedOptions);
//     };

//     loadInitialSelection();
//   }, [initialSelectedIds, initialSelectedOptions]);

//   const formattedOptions = options.map((opt) => ({
//     value: opt.id.toString(),
//     label: opt.label,
//   }));

//   return (
//     <div style={{ width: "100%" }}>
//       {DropdownHeading && (
//         <label style={{ fontWeight: "500", marginBottom: 8, marginTop: 10 }}>
//           {DropdownHeading}
//         </label>
//       )}

//       <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
//         {sideDropdownHeading && (
//           <p
//             style={{
//               color: "#2e8dd3",
//               fontWeight: "500",
//               marginRight: "5px",
//               marginLeft: "5px",
//               display: "flex",
//               alignItems: "center",
//             }}
//           >
//             {sideDropdownHeading}
//           </p>
//         )}

//         <div style={{ width: "100%" }}>
//           <Select
//             options={formattedOptions}
//             value={
//               isMulti
//                 ? selectedOptions.map((opt) => ({
//                     value: opt.id.toString(),
//                     label: opt.label,
//                   }))
//                 : selectedOptions.length
//                 ? {
//                     value: selectedOptions[0].id.toString(),
//                     label: selectedOptions[0].label,
//                   }
//                 : null
//             }
//             isDisabled={isDisabled}
//             placeholder={placeholder}
//             isSearchable
//             isMulti={isMulti}
//             onChange={(selectedOption: any) => {
//               if (isMulti) {
//                 const mapped = selectedOption.map((opt: any) => ({
//                   id: opt.value,
//                   label: opt.label,
//                 }));
//                 setSelectedOptions(mapped);
//                 onChange(mapped);
//               } else {
//                 if (!selectedOption) {
//                   setSelectedOptions([]);
//                   onChange(null); // ✅ Now valid
//                   return;
//                 }

//                 const selected = {
//                   id: selectedOption.value,
//                   label: selectedOption.label,
//                 };
//                 setSelectedOptions([selected]);
//                 onChange(selected);
//               }
//             }}
//             onInputChange={(inputValue, { action }) => {
//               if (action === "input-change") {
//                 debouncedHandleInputChange(inputValue);
//               }
//             }}
//             onMenuScrollToBottom={() => {
//               if (hasMore) {
//                 const nextPage = page + 1;
//                 setPage(nextPage);
//                 loadPage(nextPage, searchText);
//               }
//             }}
//             styles={{
//               control: (base) => ({
//                 ...base,
//                 backgroundColor: "transparent",
//                 minHeight: "42px",
//               }),
//               menuList: (base) => ({
//                 ...base,
//                 maxHeight: "150px",
//               }),
//               multiValue: (base) => ({
//                 ...base,
//                 backgroundColor: badgeBackgroundColor,
//               }),
//               multiValueLabel: (base) => ({
//                 ...base,
//                 color: "white",
//               }),
//               multiValueRemove: (base) => ({
//                 ...base,
//                 color: "white",
//                 ":hover": {
//                   backgroundColor: "#d32f2f",
//                 },
//               }),
//             }}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PaginatedRouteDropdown;
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { debounce } from "lodash";
import { Spinner } from "reactstrap";

interface OptionType {
  id: string | number;
  label: string | number;
}

interface PaginatedRouteDropdownProps {
  placeholder?: string;
  DropdownHeading?: string;
  sideDropdownHeading?: string;
  isMulti?: boolean;
  badgeBackgroundColor?: string;
  isDisabled?: boolean;
  selectedValue?: string | number | (string | number)[];
  onChange: (
    value:
      | OptionType
      | OptionType[]
      | string
      | number
      | (string | number)[]
      | null
  ) => void;

  fetchOptions: (page: number, searchText?: string) => Promise<OptionType[]>;
  initialSelectedIds?: (string | number)[];
  initialSelectedOptions?: OptionType | OptionType[] | null;
  dependencies?: any[];
  /** ✅ New prop */
  enableSelectAll?: boolean;
  asterisk?: boolean;
}

const PaginatedRouteDropdown: React.FC<PaginatedRouteDropdownProps> = ({
  placeholder = "Select an option...",
  DropdownHeading = "",
  sideDropdownHeading = "",
  isMulti = false,
  badgeBackgroundColor = "#43B9B2",
  isDisabled = false,
  selectedValue,
  onChange,
  fetchOptions,
  initialSelectedIds = [],
  initialSelectedOptions,
  dependencies = [],
  enableSelectAll = false, // ✅ default false
  asterisk = false,
}) => {
  const [options, setOptions] = useState<OptionType[]>([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [selectedOptions, setSelectedOptions] = useState<OptionType[]>([]);
  const [isAllSelected, setIsAllSelected] = useState(false); // ✅ Track select all state
  const [loading, setLoading] = useState(false);

  // const loadPage = async (pg: number, searchVal = "") => {
  //   const validDeps = dependencies?.filter(
  //     (d) => d !== null && d !== undefined && d !== ""
  //   );
  //   if (
  //     !validDeps?.length ||
  //     (Array.isArray(dependencies?.[0]) && !dependencies?.[0]?.length)
  //   ) {
  //     setOptions([]); // clear options
  //     return;
  //   }

  //   const newOptions = await fetchOptions(pg, searchVal);
  //   setOptions((prev) => (pg === 1 ? newOptions : [...prev, ...newOptions]));
  //   setHasMore(newOptions?.length >= 10);
  // };

  const loadPage = async (pg: number, searchVal = "") => {
    try {
      setLoading(true);

      if (dependencies && dependencies.length > 0) {
        const validDeps = dependencies.filter(
          (d) => d !== null && d !== undefined && d !== ""
        );

        if (
          !validDeps.length ||
          (Array.isArray(dependencies?.[0]) && !dependencies?.[0]?.length)
        ) {
          setOptions([]); // clear options
          setLoading(false);
          return;
        }
      }

      const newOptions = await fetchOptions(pg, searchVal);
      setOptions((prev) => (pg === 1 ? newOptions : [...prev, ...newOptions]));
      setHasMore(newOptions?.length >= 10);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   loadPage(1);
  // }, []);

  // Initial mount
  useEffect(() => {
    if (!dependencies || dependencies.length === 0) {
      // 👉 If no dependencies prop, call API directly
      loadPage(1);
    }
  }, []);

  // useEffect(() => {
  //   const validDeps = dependencies?.filter(
  //     (d) => d !== null && d !== undefined
  //   );
  //   if (!validDeps?.length) return;

  //   setPage(1);
  //   setSearchText("");
  //   loadPage(1);
  // }, [
  //   JSON.stringify(dependencies?.filter((d) => d !== null && d !== undefined)),
  // ]);

  useEffect(() => {
    if (dependencies && dependencies.length > 0) {
      const validDeps = dependencies.filter(
        (d) => d !== null && d !== undefined
      );
      if (!validDeps.length) return;

      setPage(1);
      setSearchText("");
      loadPage(1);
    }
  }, [
    dependencies
      ? JSON.stringify(
          dependencies.filter((d) => d !== null && d !== undefined)
        )
      : null,
  ]);

  const debouncedHandleInputChange = debounce((input: string) => {
    setSearchText(input);
    setPage(1);
    loadPage(1, input);
  }, 300);

  useEffect(() => {
    if (initialSelectedOptions) {
      const normalized = Array.isArray(initialSelectedOptions)
        ? initialSelectedOptions
        : [initialSelectedOptions];

      setSelectedOptions(normalized);

      setOptions((prev) => {
        const existingIds = prev.map((opt) => opt.id.toString());
        const newOptions = normalized.filter(
          (opt) => !existingIds.includes(opt.id.toString())
        );
        return [...newOptions, ...prev];
      });
    }
  }, [initialSelectedOptions]);

  useEffect(() => {
    if (!initialSelectedIds?.length || initialSelectedOptions) return;

    const loadInitialSelection = async () => {
      const fetchedOptions: OptionType[] = [];

      for (const id of initialSelectedIds) {
        let currentPage = 1;
        let found = false;

        while (!found) {
          const res = await fetchOptions(currentPage, id.toString());
          if (!res.length) break;

          const match = res.find((opt) => opt.id.toString() === id.toString());

          if (match) {
            fetchedOptions.push(match);
            found = true;
          } else {
            currentPage++;
          }
        }
      }

      setOptions((prev) => {
        const existingIds = prev.map((opt) => opt.id.toString());
        const newOptions = fetchedOptions.filter(
          (opt) => !existingIds.includes(opt.id.toString())
        );
        return [...newOptions, ...prev];
      });

      setSelectedOptions(fetchedOptions);
    };

    loadInitialSelection();
  }, [initialSelectedIds, initialSelectedOptions]);

  /** ✅ Add "Select All" at the top if enabled and multi */
  const formattedOptions = [
    ...(enableSelectAll && isMulti
      ? [
          {
            value: "__select_all__",
            label: isAllSelected ? "Deselect All" : "Select All",
          },
        ]
      : []),
    ...options.map((opt) => ({
      value: opt.id.toString(),
      label: opt.label,
    })),
  ];

  return (
    <div style={{ width: "100%" }}>
      {DropdownHeading && (
        <label style={{ fontWeight: "500", marginBottom: 8, marginTop: 10 }}>
          {DropdownHeading}
          {asterisk && <span style={{ color: "red" }}>*</span>}
        </label>
      )}

      <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
        {sideDropdownHeading && (
          <p
            style={{
              color: "#2e8dd3",
              fontWeight: "500",
              marginRight: "5px",
              marginLeft: "5px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {sideDropdownHeading}
          </p>
        )}

        <div style={{ width: "100%" }}>
          <Select
            options={formattedOptions}
            value={
              isMulti
                ? selectedOptions.map((opt) => ({
                    value: opt.id.toString(),
                    label: opt.label,
                  }))
                : selectedOptions.length
                ? {
                    value: selectedOptions[0].id.toString(),
                    label: selectedOptions[0].label,
                  }
                : null
            }
            isDisabled={isDisabled}
            placeholder={placeholder}
            isLoading={loading}
            noOptionsMessage={() =>
              loading ? (
                <Spinner
                  color="primary"
                  style={{ width: "1rem", height: "1rem" }}
                />
              ) : (
                "No options Found"
              )
            } // ✅ show loader / no options text
            isSearchable
            isMulti={isMulti}
            onChange={(selectedOption: any) => {
              // ✅ Handle "Select All" click
              if (
                enableSelectAll &&
                isMulti &&
                selectedOption?.some(
                  (opt: any) => opt.value === "__select_all__"
                )
              ) {
                if (isAllSelected) {
                  // Deselect all
                  setSelectedOptions([]);
                  onChange([]);
                  setIsAllSelected(false);
                } else {
                  // Select all
                  setSelectedOptions(options);
                  onChange(options);
                  setIsAllSelected(true);
                }
                return;
              }

              if (isMulti) {
                const mapped = selectedOption.map((opt: any) => ({
                  id: opt.value,
                  label: opt.label,
                }));
                setSelectedOptions(mapped);
                onChange(mapped);
                setIsAllSelected(mapped.length === options.length); // sync state
              } else {
                if (!selectedOption) {
                  setSelectedOptions([]);
                  onChange(null);
                  return;
                }

                const selected = {
                  id: selectedOption.value,
                  label: selectedOption.label,
                };
                setSelectedOptions([selected]);
                onChange(selected);
              }
            }}
            onInputChange={(inputValue, { action }) => {
              if (action === "input-change") {
                debouncedHandleInputChange(inputValue);
              }
            }}
            onMenuScrollToBottom={() => {
              if (hasMore) {
                const nextPage = page + 1;
                setPage(nextPage);
                loadPage(nextPage, searchText);
              }
            }}
            styles={{
              control: (base) => ({
                ...base,
                backgroundColor: "transparent",
                minHeight: "42px",
              }),
              menuList: (base) => ({
                ...base,
                maxHeight: "150px",
              }),
              multiValue: (base) => ({
                ...base,
                backgroundColor: badgeBackgroundColor,
              }),
              multiValueLabel: (base) => ({
                ...base,
                color: "white",
              }),
              multiValueRemove: (base) => ({
                ...base,
                color: "white",
                ":hover": {
                  backgroundColor: "#d32f2f",
                },
              }),
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default PaginatedRouteDropdown;
